// ============================================================
// FILE: src/pages/Projects.jsx
// ============================================================
import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from '../componenets/ProjectCard';

const Projects = () => {
    const projects = [
        {
            title: 'Mega Industrial Park',
            category: 'Infrastructure',
            image: '/newimg.jpeg',
        },
        {
            title: 'Mega Industrial Park',
            category: 'Infrastructure',
            image: '/newimg1.jpeg',
        },
        {
            title: 'Steel Bridge Construction',
            category: 'Structural Steel',
            image: '/newimg2.jpeg',
        },
        {
            title: 'Warehouse Complex',
            category: 'Warehouse',
            image: '/newimg3.jpeg',
        },
        {
            title: 'Steel Plant Expansion',
            category: 'Industrial',
            image: '/img1.jpeg',
        },
        {
            title: 'Commercial Tower',
            category: 'Commercial',
            image: '/img2.jpeg',
        },
        {
            title: 'Metro Station Roof',
            category: 'Infrastructure',
            image: '/img3.jpeg',
        },
    ];

    return (
        <div className="pt-24">
            <section className="section-padding">
                <div className="container-custom">
                    {/* Heading */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-center mb-12"
                    >
                        <h1 className="text-4xl md:text-5xl font-bold">
                            Our <span className="gradient-text">Projects</span>
                        </h1>
                        <p className="text-gray-400 mt-2">
                            Showcasing our expertise across diverse sectors
                        </p>
                    </motion.div>

                    {/* Projects Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {projects.map((project, index) => (
                            <ProjectCard
                                key={index}
                                {...project}
                                delay={index * 0.1}
                            />
                        ))}
                    </div>

                    {/* ============================================================
                        VIDEO SECTION — CORRECTED
                    ============================================================ */}
                    {/* ============================================================
    VIDEO SECTION
============================================================ */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="mt-20"
                    >
                        <div className="text-center mb-8">
                            <h2 className="text-2xl md:text-3xl font-bold text-slate-800">
                                See Our Work in{' '}
                                <span className="gradient-text">Action</span>
                            </h2>
                            <p className="text-gray-500 mt-2 text-sm">
                                A quick look at our fabrication and execution process
                            </p>
                        </div>

                        <div className="relative mx-auto max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-slate-900 shadow-[0_20px_60px_rgba(0,0,0,0.15)]">
                            <div className="aspect-video w-full">
                                <video
                                    className="h-full w-full object-cover"
                                    controls
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    preload="metadata"
                                >
                                    <source src="/newvedio.mp4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default Projects;